module.exports = __webpack_public_path__ + "static/media/Northville-Hills-Amended-CCR2011.0cb034b5.pdf";